import { Flex, Text, Box } from '@chakra-ui/react';

import FigmaTriangleDown from 'components/Icons/FigmaTriangleDown';

export interface FormatProperties {
  selectedColor: string;
  handleColorChange: (event: any) => void;
}

const RowTextColor = ({ selectedColor, handleColorChange }: FormatProperties) => {
  return (
    <Flex alignItems={'center'} justifyContent={'space-between'}>
      <Text fontFamily='Roboto Regular' fontWeight='500' fontSize='13px' color='#121826'>
        Text colour
      </Text>
      <Flex
        alignItems='center'
        gap='8px'
        border='1px solid #E8E9EB'
        borderRadius='8px'
        px='14px'
        h='29px'
        position='relative'
      >
        <Text
          fontFamily='Roboto Bold'
          fontWeight='700'
          fontSize='16px'
          color={selectedColor || '#121826'}
          textDecoration='underline'
        >
          A
        </Text>
        <FigmaTriangleDown width={10} height={6} color='#708090' />
        <Box
          as='input'
          // @ts-ignore native color input, only its swatch trigger is visually used
          type='color'
          value={selectedColor || '#121826'}
          onChange={(event: any) => handleColorChange(event.target.value)}
          position='absolute'
          inset={0}
          opacity={0}
          cursor='pointer'
          border='none'
          padding={0}
        />
      </Flex>
    </Flex>
  );
};
export default RowTextColor;
